module.exports = __webpack_public_path__ + "media/images/ohap_invite people_on-e17fd1253e994f0d8c087844e4e88c9b.png";